import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
} from '../../utils/event_constants';

export const pineconeActions = [
  {
    name: 'addDataKnowledgeBase',
    label: 'Add Data In Knowledge Base',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForDoc', label: 'Select Doc Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'queryFromKnowledgeBase',
    label: 'Get Answer From Knowledge Base',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForQuery', label: 'Select Query Field' }),
      collectionFieldArgsConfig({ name: 'fieldForContext', label: 'Select Context Field' }),
      {
        name: 'collectionForFileField',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
        optional: true,
      },
      collectionFieldArgsConfig({ name: 'fieldForFile', label: 'Select File Field' }),
      ...alertMessagesArgsConfig,
    ],
  },
];
